import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import {Link} from 'react-router-dom';

class OurexpertsGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ourexpertsgallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "ourexpertsGallery",
      //'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ ourexpertsgallerypage: entries.items});
    });
  }

  redirectToTarget=()=>{
    this.props.history.push('/our-experts')
  }


  render() {
    return (
    <>
      <div className="container-fluid text-left">
        <h1>OUR EXPERTS GALLERY</h1>
      </div>
      <div>
      
        {this.state.ourexpertsgallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.ourexpertsgallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-4 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.ourexpertsGalleryPhoto.fields.file.url} alt="sam bridge experts photos" /></label>
                              <label htmlFor={num}><img src={item.fields.ourexpertsGalleryPhoto.fields.file.url} alt="sam bridge experts photos" /></label>
                              {/* <p className="text-center">{item.fields.ourexpertsGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      

      </div>
      <div className="container-fluid">
      <p><Link to="#" onClick={this.redirectToTarget}><button className="btn btn-primary">Back to Our Experts</button></Link></p>
      </div>
    </>
    );
  }
}

export default OurexpertsGallery;
